import type { ApplyV2Question } from '@core/app/types/applyV2Type'
import ApplyV2QuestionsItem from '@core/components/ApplyDialogV2/ApplyV2QuestionsStep/ApplyV2QuestionsItem'
import useApplyV2NavTranslations from 'core/utils/hooks/useApplyV2NavTranslations'

interface ApplyV2QuestionsListProps {
    questions: ApplyV2Question[] | undefined | null
    // parentQuestionId?: number | null
    // parentOptionId?: number | null
    // parentValue?: any
    parent?:
        | {
              parentValue: any
              parentType: ApplyV2Question['type'] | null
              parentQuestionId: number | null
              parentOptionId: number | null
          }
        | null
        | undefined
}
const baseClass = 'ApplyV2QuestionsStep'

function ApplyV2QuestionsList({
    questions,
    // parentQuestionId = 0,
    // parentValue,
    // parentOptionId,
    parent = {
        parentQuestionId: 0,
        parentValue: null,
        parentOptionId: null,
        parentType: null,
    },
}: ApplyV2QuestionsListProps) {
    if (!questions || !questions.length) return null

    const orderedQuestions = [...questions].sort((a, b) => a.orderId - b.orderId)

    return (
        <div
            className={`${baseClass}__question--children`}
            style={{
                paddingLeft: parent?.parentQuestionId && parent?.parentQuestionId > 0 ? '14px' : '0',
                borderLeft: parent?.parentQuestionId && parent?.parentQuestionId > 0 ? '1px solid #E2E8F0' : 'none',
            }}
        >
            {orderedQuestions
                .filter((quest) => {
                    switch (parent?.parentType) {
                        case 'multiSelect':
                            return (Array.isArray(parent.parentValue) ? parent.parentValue : []).includes(
                                quest.parentOptionId
                            )
                        case 'singleSelect':
                        case 'yesNo':
                            return parent.parentValue && quest.parentOptionId === parent.parentValue
                        default:
                            return true
                    }
                })
                .map((question) => {
                    return <ApplyV2QuestionsItem key={question.questionId} question={question} />
                })}
        </div>
    )
}

export default ApplyV2QuestionsList
